import { PostoService } from './../../../base/services/posto.service';
import { PostoSelectDTO } from './../../../base/domain/dto/posto-select.dto';
import { EstadoSelectDTO } from './../../../base/domain/dto/estado-select.dto';
import { EstadoService } from 'src/app/base/services/estado.service';
import { LazyLoadEvent } from 'primeng/api';
import { QueryOptions } from './../../domain/query.options';
import { Page } from './../../../base/domain/return-api.model';
import { ConciliacaoBancaria } from './../../../base/domain/conciliacao-bancaria.model';
import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';
import { RotaService } from 'src/app/base/services/rota.service';
import { ThrowStmt } from '@angular/compiler';
import { RotaSelectDTO } from 'src/app/base/domain/dto/rota-select.dto';
import { RotaDTO } from 'src/app/base/domain/dto/rota.dto';
import { Rota } from 'src/app/base/domain/rota.model';

export interface VisualizarConciliacaoBancariaFilterOptions {
  dataInicial: Date;

  dataFinal: Date;

  estadoId: number;

  postoUID: string;

  processado: boolean;

  rotaId: number;

  nomeCliente: string;
}

export interface ConciliacaoBancariaEvent {
  acao: string;
  arquivo: ConciliacaoBancaria | ConciliacaoBancaria[];
}

@Component({
  selector: 'app-visualizar-conciliacao-list',
  templateUrl: './visualizar-conciliacao-list.component.html',
  styleUrls: ['./visualizar-conciliacao-list.component.css'],
})
export class VisualizarConciliacaoListComponent implements OnInit {
  @Output() filter = new EventEmitter<VisualizarConciliacaoBancariaFilterOptions>();
  @Output() loadArquivosPage = new EventEmitter<number>();
  @Output() acaoClick = new EventEmitter<ConciliacaoBancariaEvent>();
  @Output() menuAcaoClick = new EventEmitter<string>();
  @Output() pagarTodosOsClientes = new EventEmitter<Date[]>();

  public static CORRIGIR_PAGAMENTO_DIA = 'Corrigir pagamento por dia';
  menuAcoes: string[] = ['Corrigir pagamento por dia'];

  filterOptions: VisualizarConciliacaoBancariaFilterOptions;
  private readonly defaultFilterOptions: VisualizarConciliacaoBancariaFilterOptions = {
    dataInicial: null,
    dataFinal: null,
    estadoId: null,
    postoUID: null,
    processado: false,
    rotaId: null,
    nomeCliente: null,
  };

  @Input() page: Page<ConciliacaoBancaria>;
  @Input() totalRecords: number;
  @Input() rowsNumber: number;
  @Input() loading: boolean;
  @Input() valorTotal: number;

  private currentPage = 0;
  queryOptions = new QueryOptions();

  public estados: EstadoSelectDTO[];
  public postos: PostoSelectDTO[];
  public rotas: Rota[];
  estadoId: number;
  nomeCliente: string;

  constructor(private estadoService: EstadoService, private postoService: PostoService, private rotaService: RotaService) { }

  ngOnInit(): void {
    this.popularEstados();
    this.popularPostos();
    this.onLimparFiltros();
  }

  loadArquivos(event: LazyLoadEvent): void {
    const pageNumber = Math.floor(event.first / event.rows);
    this.currentPage = pageNumber - 1;
    this.loadArquivosPage.emit(pageNumber);
  }

  onAtualizar(): void {
    this.loadArquivosPage.emit(this.currentPage);
  }

  onMenuAcaoClick(event: string): void {
    this.menuAcaoClick.emit(event);
  }

  onAcaoClick(acao: string, domain: ConciliacaoBancaria): void {
    this.acaoClick.emit({ acao, arquivo: domain });
  }

  onLimparFiltros(): void {
    this.filterOptions = Object.assign({}, this.defaultFilterOptions);
  }

  onAplicarFiltro(): void {
    this.filter.emit(this.filterOptions);
  }

  estadoSelecionadoEvent(estadoId: number) {
    if (estadoId) {
      this.popularPostos(estadoId);
    } else {
      this.filterOptions.postoUID = null;
      this.postos = [];
    }
  }

  postoSelecionadoEvent(postoId: string) {
    if (postoId) {
      this.popularRotas(postoId);
    } else {
      this.filterOptions.rotaId = null;
      this.rotas = [];
    }
  }

  rotaSelecionadoEvent(rotaId: number) {
    if (!rotaId) {
      this.filterOptions.rotaId = null;
    }
  }

  private popularEstados() {
    this.estadoService.getSelect().subscribe((estados) => {
      this.estados = estados;
    });
  }

  private popularPostos(estadoId?: number) {
    this.estadoId = estadoId;
    this.postoService.getSelect(estadoId).subscribe((postos) => {
      this.filterOptions.postoUID = null;
      this.postos = postos;
    });
  }

  private popularRotas(postoUid?: string) {
    this.rotaService.listarRotasPorEstadoEPostoUID(this.estadoId, postoUid).subscribe((rotas) => {
      this.filterOptions.rotaId = null;
      this.rotas = rotas.object;
    });
  }

  generateMask(value: number): string {
    return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  }

  pagarTodos(): void {
    const acao = 'Corrigir pagamento';
    const { dataInicial, dataFinal } = this.filterOptions;
    console.log(dataInicial)
    console.log(dataFinal)
    if (!dataInicial || !dataFinal) {
      console.warn('Data inicial ou final não definida nos filtros.');
      return;
    }

    const datas: Date[] = [];
    const atual = new Date(dataInicial);

    atual.setHours(0, 0, 0, 0);
    const fim = new Date(dataFinal);
    fim.setHours(0, 0, 0, 0);

    while (atual <= fim) {
    datas.push(new Date(atual)); // Clona a data
    atual.setDate(atual.getDate() + 1);
  }

    this.pagarTodosOsClientes.emit(datas);
  }

}
